export default __webpack_public_path__ + "static/media/platform.776222a8.webp";